import { LinkWithChevron } from '@/components/Link/LinkWithChevron';
import { useEnvironment } from '@/cutils/context/EnvironmentContext';

import ArticleItemTeaserText from '../Article/Items/ArticleItemTeaserText';
import { SingleColumnLayout } from '../SingleColumnLayout/SingleColumnLayout';
import { SocialMediaSharer } from '../SocialMediaSharer';

import { ShortNewsArticlesLinks } from './ShortNewsArticlesLinks';
import styles from './ShortnewsDetail.module.scss';
import { ShortnewsDetailFragment } from './fragments/__generated__/ShortnewsDetail.generated';

type Props = {
	byEditorialTeam: string;
	id: string;
	omId: string | null | undefined;
	path: string | null | undefined;
	shareUrl: string | null | undefined;
	text: string | null | undefined;
	title: string | null | undefined;
	updateDate: string | null;
	shortNewsList: ShortnewsDetailFragment[];
};

// Old shortnews to test: http://localhost:8081/nachrichten/meldung/eu-steht-vor-wochenlangem-ringen-um-neuen-kommissionspraesidenten,300179c6c

export function ContentPageShortnewsDetail({ updateDate, byEditorialTeam, id, shareUrl, text, title, shortNewsList }: Props) {
	const {
		constants: { appUrl },
	} = useEnvironment();
	const validatedShareUrl = !!shareUrl ? shareUrl : `${appUrl}/meldung`;

	const source = `Sendung: ${byEditorialTeam}, ${updateDate}`;

	return (
		<SingleColumnLayout contentClassName={styles.content}>
			<article id={id}>
				<h1 className={styles.title}>{title}</h1>

				<ArticleItemTeaserText className="body3">{text}</ArticleItemTeaserText>

				<p className={`${styles.source} heading4`}>{source}</p>

				<SocialMediaSharer className={styles.sharer} commentId={undefined} direction="horizontal" url={validatedShareUrl} />

				<div className={styles.shortnews}>
					<h2 className={styles.shortnewsTitle}>Weitere Meldungen</h2>
					<ShortNewsArticlesLinks shortNewsList={shortNewsList} />
				</div>

				<LinkWithChevron className="heading3" href="/">
					Zur BR24 Startseite
				</LinkWithChevron>
			</article>
		</SingleColumnLayout>
	);
}
